import React, { useState, useEffect, Fragment, useContext } from "react";
import { Typography } from "@material-ui/core";
import { Add, Dashboard as DashboardIcon } from "@material-ui/icons";
import { SecondaryAppBar } from "../common/SecondaryAppBar";
import { NewComplaintDialog } from "./NewComplaintDialog";
import { useDispatch, useSelector } from "react-redux";
import { loadComplaints } from "../../redux/actions";
import { selectComplaints } from "../../redux/selectors";
import CaseRow from "./CaseRow";
import { useNavigate } from "../../hooks/useNavigate";
import { CaseRoles } from "../../auth/CaseRoles";
import { useAuthorizationRoleOnly } from "../../hooks/useAuthorization";
import { HistoryContext } from "../../redux/historyContext";
import { Pager } from "./Pager";
import { FilterControls } from "./FilterControls";
import { Link } from "react-router-dom";
import { useSearch, useUrl } from "@ofqual/portal-core/core/hooks";
export const Dashboard = () => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const complaintsState = useSelector(selectComplaints);
    const { data: pagedResponse, loadingState } = complaintsState;
    const { location } = useContext(HistoryContext);
    const navigate = useNavigate(location);
    const { searchParams, searchParamsFiltersOnly, navigateToNextPage } = useSearch(useUrl());
    const navigateToCase = (id) => navigate(`/complaints/${id}/activity`);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(loadComplaints(searchParams));
    }, [dispatch, searchParams]);
    const isAuthedForCreate = useAuthorizationRoleOnly(CaseRoles.admin, CaseRoles.helpdesk);
    const actions = [
        {
            title: "New Case",
            onClick: () => setIsDialogOpen(true),
            startIcon: React.createElement(Add, null),
            disabled: !isAuthedForCreate,
            "data-test": "new-case",
        },
        {
            title: "Dashboard",
            onClick: () => navigate("/complaints"),
            startIcon: React.createElement(DashboardIcon, null),
            disabled: false,
            "data-test": "dashboard",
        },
    ];
    const { data } = pagedResponse;
    if (loadingState === "NOT_LOADED") {
        return React.createElement(Typography, { variant: "body1" }, "Loading, please wait...");
    }
    return (React.createElement(Fragment, null,
        React.createElement(SecondaryAppBar, { actions: actions, title: React.createElement(React.Fragment, null, searchParams.DashboardTitle ? (React.createElement(React.Fragment, null,
                React.createElement(Link, { to: `/complaints/list`, "data-test-id": "secondary-header-root-link" }, "/ All cases"),
                " ",
                "/ ",
                searchParams.DashboardTitle)) : ("/ All cases")) },
            React.createElement(FilterControls, { navigate: navigateToNextPage, params: searchParams, searchParamsFiltersOnly: searchParamsFiltersOnly })),
        React.createElement(Pager, { complaintsState: complaintsState, isTopPager: true, navigate: navigateToNextPage, params: searchParams }),
        data.map(element => {
            return React.createElement(CaseRow, { key: element.id, element: element, onNavigate: navigateToCase });
        }),
        !data.length && loadingState === "LOADED" && (React.createElement(Typography, { variant: "body1" }, "No cases to view")),
        React.createElement(Pager, { complaintsState: complaintsState, navigate: navigateToNextPage, params: searchParams }),
        isDialogOpen && (React.createElement(NewComplaintDialog, { isDialogOpen: isDialogOpen, onDialogClose: () => setIsDialogOpen(false) }))));
};
